import { defineWsRoute, event } from "@bigswiss-gmbh/fast-ws";
import { AppDispatch } from "store";
import { setNewVerificationAction, setVerificationStatus } from "store/auth/authSlice";

// Identity WS route for FastWS client.
// Normalizes payload to the existing Redux actions without changing slices/selectors.
export const identityRoute = defineWsRoute([
  event("verificationStatus", (data: any, dispatch: AppDispatch) => {
    try {
      if (data && typeof data === "object") {
        if (data.status) {
          dispatch(setVerificationStatus(String(data.status)));
        }
        if ("verificationSecret" in data || "verificationError" in data) {
          dispatch(
            setNewVerificationAction({
              verificationSecret: data.verificationSecret ?? null,
              verificationError: data.verificationError ?? null,
            }),
          );
        }
      }
    } catch (err) {
      // keep silent; adapter should not throw
      console.error("[identityRoute] dispatch error", err);
    }
  }),
]);

